import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import BetChipSection from '../../betChipSection';
import { ExtraBetsOddSection } from '../../extraBetsOddSection';

export const FlopCardsRow = observer(
  ({ betTypeInfo, winningBoardCardTypes, currentGroupTypesInfo, groupType, handleDoChip }) => {
    const t = useTranslation();
    const handleIsAllowDoChip = useCallback(
      (data) => {
        if (currentGroupTypesInfo) {
          const isNotAllow = currentGroupTypesInfo?.selections?.some(
            (item) => item?.isWin || item?.odd <= 1
          );
          if (isNotAllow) {
            return;
          }
          handleDoChip(data);
        }
      },
      [currentGroupTypesInfo, handleDoChip]
    );

    return (
      <div className='flop-c-row-wrapper'>
        {betTypeInfo.map(({ imgSrc, marketType, name }, index) => (
          <div
            key={'item'.concat(`${index}`)}
            className='flop-c-row-wrapper-inner'
            onClick={() =>
              handleIsAllowDoChip({ betType: `${groupType}-${marketType}`, groupType })
            }
          >
            {imgSrc ? (
              <>
                <div className='flop-c-img-cont'>
                  {/* TODO ADD img */}
                  <img className='flop-c-img-inner' src={imgSrc} alt='#' />
                </div>
                <p className='flop-c-row-text'>{t(name)}</p>
              </>
            ) : (
              <>
                <ExtraBetsOddSection
                  isOddLose={winningBoardCardTypes?.length}
                  currentSelection={currentGroupTypesInfo?.selections?.find(
                    (item) => item.marketType === marketType
                  )}
                />
                <BetChipSection
                  isLittleChip
                  betType={`${groupType}-${marketType}`}
                  groupType={groupType}
                />
              </>
            )}
          </div>
        ))}
      </div>
    );
  }
);
